import useToast from "../../hooks/useToast";
import ToastStore from "../../stores/ToastStore";
import connectToStores from "../providers/connectToStores";

const Toast = ({ toast }) => useToast(toast);

export default connectToStores(Toast, [
  {
    store: ToastStore,
    state: { toast: null },
  },
]);
